"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCard = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCard_base_1 = require("./DocumentCard.base");
var DocumentCard_styles_1 = require("./DocumentCard.styles");
exports.DocumentCard = (0, Utilities_1.styled)(DocumentCard_base_1.DocumentCardBase, DocumentCard_styles_1.getStyles, undefined, { scope: 'DocumentCard' });
//# sourceMappingURL=DocumentCard.js.map